<template>
  <div class="credit-card">
    <img :src="imageUrl" :alt="name" />
  </div>
</template>
<script>
export default {
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  }
}
</script>
